module.exports = __webpack_public_path__ + "static/media/merkuriusz.508eb2fe.JPG";